import {parseToolResult} from "@repo/ui/gailgpt/code-execution";
import type {ConversationMessage} from "@/services/wingman";

/** Native publication receipts, including continuations that did not save a draft. */
export function confirmedWorkflowPublications(messages: ConversationMessage[]) {
   return messages.flatMap(message => message.contents.flatMap(part => {
      if (part.type !== "function_result" || part.functionName !== "omega_publishcustomerworkflow") return [];
      const workflow = readPublicationReceipt(part.result);
      return workflow ? [{callId: part.callId, workflow}] : [];
   }));
}

/** Only a matching, published receipt can identify the workflow represented by a review. */
export function readPublicationReceipt(value: unknown, reviewedId?: string | null) {
   const output = parseToolResult(value);
   const workflow = parseToolResult(output?.workflow);
   if (output?.status !== "published" || workflow?.status !== "published") return undefined;
   if (typeof workflow.id !== "string" || !workflow.id.trim() || (reviewedId && workflow.id !== reviewedId)) return undefined;
   return {id: workflow.id, name: workflow.name, revision: workflow.revision};
}
